import React from "react";

export default function ProfileAboutPage({ business }) {
  console.log(business);
  return <div id="about">{business.meta_data.business_description}</div>;
}
